import React from 'react'

import { string } from 'prop-types'

import CardActions from 'components/atoms/CardActions'
import Typography from 'components/atoms/Typography'
import intl from 'react-intl-universal'

import { SVGIcon } from 'components/qstrap'

import config from 'config'

const { assets_url: assetsUrl } = config

const ExplorationCard = ({ title, description, targetUrl }) => (
  <a
    className="exploration-card"
    href={targetUrl}
    target="_blank"
    rel="noopener"
  >
    <Typography component="h2" variant="headline">
      {intl.get(title)}
    </Typography>
    <Typography component="p" variant="body" className="m-y-md">
      {description}
    </Typography>
    <CardActions>
      <Typography
        variant="subbody"
        className="exploration-card__see-more font-weight-bold"
      >
        Selengkapnya
        <SVGIcon name="common-next" />
      </Typography>
    </CardActions>
    <style jsx>
      {`
        .exploration-card {
          display: block;
          color: unset;
          flex-basis: 50%;
          background-color: #fff;
          border-radius: 8px;
          box-shadow: 0 1px 3px 0 #a3b4ca;
          padding: 24px;
          background-image: url(${assetsUrl}/assets/img/exploration/${title}.png);
          background-position: bottom right;
          background-repeat: no-repeat;
          &:hover {
            text-decoration: none;
          }
          :global(&__see-more) {
            color: #00C2BF !important;
          }
        }
    `}
    </style>
  </a>
)

ExplorationCard.propTypes = {
  title: string,
  description: string,
  targetUrl: string,
}

export default ExplorationCard
